import { put, select, take } from 'redux-saga/effects';
import { apiAction, get, mapStateToArgs } from 'ctm-util-functions';

/**
 * Run the API onNext actions for a page.
 * This is slow because each action makes an async API call.
 * @param {Object} page - Current journey page.
 * @param {Object} pageState - Tightly coupled to PageWrapper mapStateToProps(), it has all page settings.
 */
export const runApiOnNextForPage = function* (page, pageState) {
    // Run the onNext action for the current page.
    const apiOnNext = get(page, 'api.onNext');
    let restArgs;
    if (apiOnNext) {
        if (apiOnNext.restArgs) {
            restArgs = yield select(mapStateToArgs, apiOnNext.restArgs);
        }
        if (apiOnNext.queryStringArgs) {
            apiOnNext.queryStringValues = yield select(mapStateToArgs, apiOnNext.queryStringArgs);
        }
        const action = apiAction(apiOnNext, pageState, restArgs, apiOnNext.baseUrl);
        yield put(action);
        yield take(`${action.type}_SUCCESS`);
    }
};
